export default __webpack_public_path__ + "static/media/init.3c6b76e8.jpg";